<div class="p-grid" id="mu-profile-verify-code">
  <div class="p-col-12 mu-without-padding">
    <form class="mu-position-relative mu-form-content" [formGroup]="formData" *ngIf="formData" autocomplete="nope">
      <div class="mu-custom-grid-container">
        <div class="mu-custom-cell" *ngFor="let input of formInputs; index as i">
          <input
            #formRow
            pInputText
            type="text"
            formControlName="{{ input }}"
            maxlength="1"
            (keyup)="keyUpEvent($event, i)"
            class="mu-input-opt"
            autocomplete="nope"
            [ngClass]="{ 'mu-profile-code-error': showErrorCode }"
            [ngClass]="{ 'mu-profile-code-success': formData?.valid }"
          />
          <em *ngIf="showErrorCode" class="fas fa-times-circle mu-error-input mu-profile-icon-error"></em>
          <em *ngIf="formData?.valid" class="fas fa-check-circle mu-succes-input mu-profile-icon-success"></em>
        </div>
      </div>
    </form>
  </div>
  <div class="p-col-12 mu-without-padding">
    <div class="p-grid mu-profile-countdown" *ngIf="!countdown">
      <div class="p-col">{{ 'sms.verifyCode.resendCode' | translate }}: 00:{{ seconds }} {{ 'sms.verifyCode.seconds' | translate }}</div>
    </div>
    <div class="p-grid mu-profile-resend-code" *ngIf="countdown">
      <div class="p-col">
        <span (click)="emitAction()">
          {{ 'sms.verifyCode.resendCode' | translate }}
        </span>
      </div>
    </div>
  </div>
</div>
